export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/google-play-badge.9d7e8a68.svg","height":38,"width":121};